module.exports = __webpack_public_path__ + "static/sponsorship-ccfe0f4dcd66fa6f16a2b1396974b22e.svg";